import { COLOR_PER_DOG_BREEDER_LAST_CONNECTED_TYPE } from '@presentation/constants';
import { useTranslation } from '@presentation/utils';
import type{ FC } from 'react';
import * as Styled from './styled';
import type { ConnectionTagProps } from './types';

export * from './types';

export const ConnectionTag: FC<ConnectionTagProps> = (props) => {
  const { type, ...rest } = props;
  const { translate } = useTranslation();

  return (
    <Styled.ConnectionTag
      color={
        COLOR_PER_DOG_BREEDER_LAST_CONNECTED_TYPE[
          type as keyof typeof COLOR_PER_DOG_BREEDER_LAST_CONNECTED_TYPE
        ] as any
      }
      {...rest}
    >
      {translate(`enum.lastConnectedType.${type}`)}
    </Styled.ConnectionTag>
  );
};
